export default "__VITE_ASSET__D5WTMi$Y__"